// extracted by mini-css-extract-plugin
export default {"nav":"AppNav_nav__fOVD0","list":"AppNav_list__HHDJ5","link":"AppNav_link__ke5iJ","cta":"AppNav_cta__AG4V3","navOpen":"AppNav_navOpen__h95P1"};